const currentHost = window.location.hostname || '127.0.0.1';
const runtimeConfig = window.JC_WEB_IM_CONFIG || {};
const browserUserAgent = window.navigator?.userAgent || '';
const webPlatform = /Edg\//.test(browserUserAgent) ? 6 : 5;
const runtimePlatform = Number(runtimeConfig.platform);
const clientPlatform = runtimePlatform > 0 ? runtimePlatform : webPlatform;
const openIMApiOrigin = `${window.location.protocol}//${currentHost}:10002`;
const chatApiOrigin = `${window.location.protocol}//${currentHost}:10008`;
const adminApiOrigin = `${window.location.protocol}//${currentHost}:10009`;
const wsOrigin = `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${currentHost}:10001`;
const openIMAssetVersion = '3.8.3-patch.14';

function versionedOpenIMAsset(path) {
  const value = String(path || '');
  if (/[?&]v=/.test(value)) {
    return value;
  }
  const separator = value.includes('?') ? '&' : '?';
  return `${value}${separator}v=${encodeURIComponent(openIMAssetVersion)}`;
}

export const appConfig = {
  appName: 'EzLife',
  serviceOrigin: runtimeConfig.serviceOrigin || window.location.origin,
  capacitorApp: Boolean(runtimeConfig.capacitorApp),
  adminServer: runtimeConfig.adminServer || process.env.VUE_APP_ADMIN_SERVER || adminApiOrigin,
  appServer: runtimeConfig.appServer || runtimeConfig.chatApiServer || process.env.VUE_APP_APP_SERVER || chatApiOrigin,
  chatApiServer: runtimeConfig.chatApiServer || runtimeConfig.appServer || process.env.VUE_APP_CHAT_API_SERVER || chatApiOrigin,
  openIMApiServer: runtimeConfig.openIMApiServer || process.env.VUE_APP_OPENIM_API_SERVER || openIMApiOrigin,
  platformConfigApi: runtimeConfig.platformConfigApi || process.env.VUE_APP_PLATFORM_CONFIG_API || '',
  registerConfigApi: runtimeConfig.registerConfigApi || process.env.VUE_APP_REGISTER_CONFIG_API || '',
  registerPhoneExistsApi: runtimeConfig.registerPhoneExistsApi || process.env.VUE_APP_REGISTER_PHONE_EXISTS_API || '',
  authApiMode: 'openim',
  openIMDefaultAreaCode: runtimeConfig.openIMDefaultAreaCode || process.env.VUE_APP_OPENIM_DEFAULT_AREA_CODE || '+86',
  skipRegisterPhoneExists: Boolean(runtimeConfig.skipRegisterPhoneExists ?? process.env.VUE_APP_SKIP_REGISTER_PHONE_EXISTS === 'true'),
  imServerHost: runtimeConfig.imServerHost || process.env.VUE_APP_IM_SERVER_HOST || currentHost,
  imRoutePort: Number(runtimeConfig.imRoutePort || process.env.VUE_APP_IM_ROUTE_PORT || 18000),
  useWss: runtimeConfig.useWss ?? process.env.VUE_APP_USE_WSS === 'true',
  wsPath: runtimeConfig.wsPath || process.env.VUE_APP_WS_PATH || '/ws',
  wsUrl: runtimeConfig.wsUrl || process.env.VUE_APP_WS_URL || wsOrigin,
  sdkMode: 'openim',
  openIMWasmCorePath: versionedOpenIMAsset(runtimeConfig.openIMWasmCorePath || process.env.VUE_APP_OPENIM_WASM_CORE_PATH || '/openIM.wasm'),
  openIMSqlWasmPath: versionedOpenIMAsset(runtimeConfig.openIMSqlWasmPath || process.env.VUE_APP_OPENIM_SQL_WASM_PATH || '/sql-wasm.wasm'),
  openIMHashPassword: runtimeConfig.openIMHashPassword ?? process.env.VUE_APP_OPENIM_HASH_PASSWORD !== 'false',
  openIMSdkDebug: Boolean(runtimeConfig.openIMSdkDebug ?? process.env.VUE_APP_OPENIM_SDK_DEBUG === 'true'),
  openIMLogLevel: Number(runtimeConfig.openIMLogLevel || process.env.VUE_APP_OPENIM_LOG_LEVEL || 3),
  syncIntervalMs: Number(runtimeConfig.syncIntervalMs || process.env.VUE_APP_SYNC_INTERVAL_MS || 1500),
  // OpenIM keeps one active token per user and platform. Give Edge its own
  // supported web platform slot so it can stay signed in alongside Chrome.
  platform: clientPlatform,
  clientIdStorageKey: 'jc-openim-client-id'
};
